import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Cardio.module.css';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBoxObjective, DBTextAreaObjective, DBIntFieldObjective, StatusCritical } from '_components';

class PatientCareCenterNoteObjectiveCardio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trials: props.trials
    };
  }

  getWarningText = (trial) => {
    const messages = [];
    if (trial.hr > 100) messages.push("Heart Rate exceeds 100 bpm");
    if (trial.sys < 90 || trial.sys > 160) messages.push("Systolic BP out of range (90–160 mmHg)");
    if (trial.dias < 60 || trial.dias > 100) messages.push("Diastolic BP out of range (60–100 mmHg)");
    return messages.join('; ');
  };


  handleClick(selected) {
    if (selected) {
      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREHR');
      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREBPSYS');
      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREBPDIAS');

      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREHR2');
      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREBPSYS2');
      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREBPDIAS2');

      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREHR3');
      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREBPSYS3');
      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPREBPDIAS3');

      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPOSTHR');
      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPOSTBPSYS');
      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, 'OOCARDIOPOSTBPDIAS');
    }
  }

  clearTrialFields = (trial, index) => {
    trial.hr = null;
    trial.sys = null;
    trial.dias = null;
    trial.isValid = null;
    trial.show = false;
    const suffix = index === 0 ? '' : `${index + 1}`;
    const baseField = `OOCARDIOPRE`;

    // Dispatch Redux actions to clear values
    const fields = ['HR', 'BPSYS', 'BPDIAS'];
    fields.forEach((part) => {
      const fieldName = `${baseField}${part}${suffix}`;
      this.props.clearField(this.props.noteId, 'PTOBJECTIVEOBS', 'OONO', this.props.oono, fieldName);
    });
  };

  handleValueChange = (field, value, index) => {
    const updatedTrials = [...this.state.trials];

    const parsed = value === '' ? null : parseInt(value, 10);
    updatedTrials[index][field] = Number.isNaN(parsed) ? null : parsed;

    for (let i = 0; i < updatedTrials.length; i++) {
      const trial = updatedTrials[i];
      const { hr, sys, dias } = trial;

      const isComplete = hr !== null && sys !== null && dias !== null;

      if (isComplete) {
        const isHRValid = hr <= 100;
        const isSysValid = sys >= 90 && sys <= 160;
        const isDiasValid = dias >= 60 && dias <= 100;
        trial.isValid = isHRValid && isSysValid && isDiasValid;
      } else {
        trial.isValid = null;
      }

      if (i === 0) {
        trial.show = true;
      } else {
        const prev = updatedTrials[i - 1];
        trial.show =
          prev.hr !== null &&
          prev.sys !== null &&
          prev.dias !== null &&
          prev.isValid === false;
      }
    }

    if (updatedTrials[0].isValid === null) {
      for (let i = 1; i < updatedTrials.length; i++) {
        this.clearTrialFields(updatedTrials[i], i);
      }
      this.setState({ trials: updatedTrials });
    } else {
      let firstClearIndex = null;
      for (let i = 0; i < updatedTrials.length; i++) {
        const trial = updatedTrials[i];
        if (!trial.show) {
          if (i === 0) {
            firstClearIndex = 0;
            break;
          } else {
            const prev = updatedTrials[i - 1];
            const prevIsEmpty =
              prev.hr === null && prev.sys === null && prev.dias === null;
            const prevIsValid = prev.isValid === true;

            if (prevIsEmpty || prevIsValid) {
              firstClearIndex = i;
              break;
            } else {
              firstClearIndex = null;
              break;
            }
          }
        }
      }

      if (firstClearIndex !== null) {
        for (let i = firstClearIndex; i < updatedTrials.length; i++) {
          this.clearTrialFields(updatedTrials[i], i);
        }
      }

      this.setState({ trials: updatedTrials });
    }


  };


  renderTrialRow = (label, index) => {
    const trial = this.props.trials[index];
    if (!trial || !trial.show) return null;

    const suffix = index === 0 ? '' : (index + 1).toString();
    const hrField = `OOCARDIOPREHR${suffix}`;
    const sysField = `OOCARDIOPREBPSYS${suffix}`;
    const diasField = `OOCARDIOPREBPDIAS${suffix}`;

    return (
      <div className={styles.row} key={index}>
        <div className={styles.cell_wrapper}>
          <span className={styles.pre_flag} />
        </div>
        <div className={styles.cell_wrapper}>
          <label className={this.props.noteType === 1 ? styles.label_req : styles.label}>{label}</label>
        </div>
        <div className={styles.cell_wrapper}>
          <label className={this.props.noteType === 1 ? styles.field_gap_req : styles.field_gap}>Heart Rate:</label>
        </div>
        <div className={styles.cell_wrapper}>
          <DBIntFieldObjective
            noteId={this.props.noteId}
            entity='PTOBJECTIVEOBS'
            entityKeyColumn='OONO'
            entityKeyValue={this.props.oono}
            field={hrField}
            className={styles.field}
            onChange={(value) => this.handleValueChange('hr', value, index)}
          />
        </div>
        <div className={styles.cell_wrapper}>
          <span className={styles.row_label_gap}>bpm</span>
        </div>
        <div className={styles.cell_wrapper}>
          <label className={this.props.noteType === 1 ? styles.section_gap_req : styles.section_gap}>Blood Pressure:</label>
        </div>
        <div className={styles.cell_wrapper}>
          <DBIntFieldObjective
            noteId={this.props.noteId}
            entity='PTOBJECTIVEOBS'
            entityKeyColumn='OONO'
            entityKeyValue={this.props.oono}
            field={sysField}
            className={styles.field}
            onChange={(value) => this.handleValueChange('sys', value, index)}
          />
        </div>
        <div className={styles.cell_wrapper}>
          <span className={styles.row_label_gap}>/</span>
        </div>
        <div className={styles.cell_wrapper}>
          <DBIntFieldObjective
            noteId={this.props.noteId}
            entity='PTOBJECTIVEOBS'
            entityKeyColumn='OONO'
            entityKeyValue={this.props.oono}
            field={diasField}
            className={styles.field}
            onChange={(value) => this.handleValueChange('dias', value, index)}
          />
        </div>
        <div className={styles.cell_wrapper}>
          <span className={styles.row_label_gap}>mmHg</span>
        </div>

        {trial.isValid === false && trial.hr !== null && trial.sys !== null && trial.dias !== null && (
          <div className={styles.cell_wrapper}>
            <span className={styles.critical_gap}>
              <StatusCritical
                size='smaller'
                title={this.getWarningText(trial)}
              />
            </span>
          </div>
        )}
      </div>
    );
  };

  render() {
    const allThreeFailed = this.props.trials.every(trial =>
      trial.hr !== null &&
      trial.sys !== null &&
      trial.dias !== null &&
      trial.isValid === false
    );

    return (
      <PatientCareCenterNoteSection id='obj_car' name='Cardiovascular' level={5}>
        <div className={styles.row}>
          <div className={styles.flag} />
          <DBCheckBoxObjective
            noteId={this.props.noteId}
            entity='PTOBJECTIVEOBS'
            entityKeyColumn='OONO'
            entityKeyValue={this.props.oono}
            field='OOCARDIONOTTESTED'
            className={styles.checkbox}
            label='Not tested at this time'
            onClick={(selected) => this.handleClick(selected)}
          />
        </div>
        {this.props.isNotTestedSelected ? (
          <div className={styles.row}>
            <div className={styles.row}>
              <span className={styles.txt_flag} />
              <div className={styles.row}>
                <label className={this.props.noteType === 1 ? styles.textarea_label_req : styles.textarea_label}>Reason BP was not tested:</label>
              </div>

              <DBTextAreaObjective
                noteId={this.props.noteId}
                entity='PTOBJECTIVEOBS'
                entityKeyColumn='OONO'
                entityKeyValue={this.props.oono}
                field='OOCARDIONOTTESTEDREASON'
                className={styles.textarea}
              />

            </div>
          </div>
        ) :
          <div className={styles.row}>

            {this.renderTrialRow("Pre-Test (Trial 1):", 0)}
            {this.renderTrialRow("Pre-Test (Trial 2):", 1)}
            {this.renderTrialRow("Pre-Test (Trial 3):", 2)}

            <div className={styles.row}>
              <div className={styles.row}>
                <div className={styles.cell_wrapper}>
                  <span className={styles.pre_flag} />
                </div>
                <div className={styles.cell_wrapper}>
                  <label className={styles.post_label}>Post-Test:</label>
                </div>
                <div className={styles.cell_wrapper}>

                  <label className={styles.field_gap}>Heart Rate:</label>
                </div>
                <div className={styles.cell_wrapper}>
                  <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOCARDIOPOSTHR'
                    className={styles.field}
                  />
                </div>
                <div className={styles.cell_wrapper}>
                  <span className={styles.row_label_gap}>bpm</span>
                </div>
                <div className={styles.cell_wrapper}>

                  <label className={styles.section_gap}>Blood Pressure:</label>
                </div>
                <div className={styles.cell_wrapper}>
                  <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOCARDIOPOSTBPSYS'
                    className={styles.field}
                  />
                </div>
                <div className={styles.cell_wrapper}>
                  <span className={styles.row_label_gap}>/</span>
                </div>
                <div className={styles.cell_wrapper}>
                  <DBIntFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOCARDIOPOSTBPDIAS'
                    className={styles.field}
                  />
                </div>
                <div className={styles.cell_wrapper}>
                  <span className={styles.row_label_gap}>mmHg</span>
                </div>

              </div>


            </div>

            {allThreeFailed && (<div className={styles.row}>
              <div className={styles.flag} />
              <DBCheckBoxObjective
                noteId={this.props.noteId}
                entity='PTOBJECTIVEOBS'
                entityKeyColumn='OONO'
                entityKeyValue={this.props.oono}
                field='OOCARDIOMDCLEARANCE'
                className={styles.checkbox}
                label='BP/HR clearance provided by MD'
              />
            </div>)}


            {(allThreeFailed && !this.props.clearanceSelected) && (
              <div className={styles.warning_space}>
                <div className={styles.row}>

                  <div className={styles.warning_flag} />
                  <StatusCritical
                    size='extra-small'
                    title='Unable to proceed with visit due to elevated vitals. Require medical clearance to resume and reschedule the visit.'
                  />
                  <span className={styles.warning_lbl}>Unable to proceed with visit due to elevated vitals. Require medical clearance to resume and reschedule the visit.</span>
                </div>

              </div>
            )}
          </div>

        }


        <div className={styles.row}>
          <div className={styles.flag} />
          <DBCheckBoxObjective
            noteId={this.props.noteId}
            entity='PTOBJECTIVEOBS'
            entityKeyColumn='OONO'
            entityKeyValue={this.props.oono}
            field='OOCARDIOONHOLD'
            className={styles.checkbox}
            label='Testing placed on hold'
            onClick={(selected) => this.handleClick(selected)}
          />
        </div>
        {this.props.onHoldSelected &&
          <div className={styles.row}>
            <span className={styles.txt_flag} />
            <div className={styles.row}>
              <label className={styles.textarea_label}>Reason:</label>
            </div>

            <DBTextAreaObjective
              noteId={this.props.noteId}
              entity='PTOBJECTIVEOBS'
              entityKeyColumn='OONO'
              entityKeyValue={this.props.oono}
              field='OOCARDIOONHOLDREASON'
              className={styles.textarea}
            />

          </div>
        }

      </PatientCareCenterNoteSection>

    );
  }

}

function mapDispatchToProps(dispatch) {
  return {
    clearField: bindActionCreators(noteActions.clearField, dispatch),
  };
}

function mapStateToProps(state) {
  let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
  let noteType = parseInt(noteId.split("_")[0]);
  let pk = parseInt(noteId.split("_")[1]);
  let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
    .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
      || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));


  const data = state.entities.notes.PTOBJECTIVEOBS[oono] || {};

  const getValue = (field) => {
    const val = data[field];
    return val !== undefined && val !== null ? parseInt(val, 10) : null;
  };

  const createTrial = (suffix = '') => {
    const hr = getValue(`OOCARDIOPREHR${suffix}`);
    const sys = getValue(`OOCARDIOPREBPSYS${suffix}`);
    const dias = getValue(`OOCARDIOPREBPDIAS${suffix}`);

    const isComplete = hr !== null && sys !== null && dias !== null;

    let isValid = null;
    if (isComplete) {
      const isHRValid = hr <= 100;
      const isSysValid = sys >= 90 && sys <= 160;
      const isDiasValid = dias >= 60 && dias <= 100;
      isValid = isHRValid && isSysValid && isDiasValid;
    }
    return { hr, sys, dias, isValid };
  };

  let trial1 = createTrial('');
  let trial2 = createTrial('2');
  let trial3 = createTrial('3');

  // Control which trials are shown
  trial1.show = true;
  trial2.show = trial1.isValid === false;
  trial3.show = trial2.isValid === false;
  return {
    noteType,
    noteId: noteId,
    clearanceSelected: (state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIOMDCLEARANCE !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIOMDCLEARANCE !== null)
      || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIOMDCLEARANCE !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIOMDCLEARANCE !== null) ? true : false,
    trials: [trial1, trial2, trial3],
    trialsData: state.entities.notes.PTOBJECTIVEOBS[oono] || {},
    oono: oono,
    isNotTestedSelected: (state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIONOTTESTED !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIONOTTESTED !== null)
      || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIONOTTESTED !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIONOTTESTED !== null)
      ? true : false,
    onHoldSelected: (state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIOONHOLD !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIOONHOLD !== null)
      || (state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIOONHOLD !== undefined && state.entities.notes.PTOBJECTIVEOBS[oono].OOCARDIOONHOLD !== null) ? true : false
  };
}

const connectedPatientCareCenterNoteObjectiveCardio = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteObjectiveCardio);
export { connectedPatientCareCenterNoteObjectiveCardio as PatientCareCenterNoteObjectiveCardio };

